import { addClass } from '@studiometa/js-toolkit/utils';
import { animate } from 'motion';
import { outQuart } from '../utilities/easings.js';

import AbstractScrollRevealChild from './AbstractScrollRevealChild.js';

/**
 * ScrollRevealTitle class.
 */
export default class ScrollRevealTitle extends AbstractScrollRevealChild {
  /**
   * Config.
   */
  static config = {
    name: 'ScrollRevealTitle',
    options: {
      delay: {
        type: Number,
        default: 0,
      },
    },
  };

  /**
   * Class mounted.
   */
  mounted() {
    this.render();
    this.animate();
  }

  /**
   * Generate markup.
   */
  render() {
    const wordsSpans = this.innerHTMLToSpans(this.$el, 2);
    const whiteSpaceSpan = '<span> </span>';
    this.$el.innerHTML = wordsSpans.map((wordsSpan) => wordsSpan.outerHTML).join(whiteSpaceSpan);

    addClass(this.$el, 'active');
  }

  /**
   * Animate.
   */
  animate() {
    const spans = this.$el.querySelectorAll(':scope > span');

    spans.forEach((span) => {
      const innerSpan = span.querySelectorAll('span');

      if (innerSpan.length === 0) {
        return;
      }

      const delay = 0.001 * (this.$options.delay + 2.5 * span.offsetTop);
      const duration = 0.001 * (1600 - delay);

      animate(
        innerSpan,
        {
          y: [span.offsetHeight, 0],
        },
        { delay, duration, easing: outQuart }
      );
    });
  }

  /**
   * Wrap innerHTML words in individual spans.
   * @param {HTMLElement} HTMLElement
   * @param {number} spanNestingLevel
   * @returns {HTMLSpanElement[]}
   */
  innerHTMLToSpans(HTMLElement, spanNestingLevel = 1) {
    const innerHTML = HTMLElement.innerHTML.trim();
    const whiteSpaceRegex = / +/g;
    const words = innerHTML.split(whiteSpaceRegex);

    const wordsSpans = words.map((word) => {
      const span = document.createElement('span');

      span.innerHTML = `${[...Array(spanNestingLevel)].join('<span>')}${word}${[
        ...Array(spanNestingLevel),
      ].join('</span>')}`;

      return span;
    });

    return wordsSpans;
  }
}
